<template>
    <div>
        <addProductLicense ref="modalLicense" @ok="modalFormOk" @close="modalFormClose" :materialIds="materialIds"></addProductLicense>
        <a-modal :title="title" :visible='sureVisible' :width="1600" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <div class="table-operator" style="margin-top: 5px">
                    <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
                </div>
                <a-table ref="table" size="middle" bordered
                    :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)" 
                    :pagination="ipagination" :loading="loading" 
                    style="word-break: break-all;">
                    <span slot="action" slot-scope="text, record">
                    <a type="primary" @click="handleEdit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                        <a type="primary">删除</a>
                    </a-popconfirm>
                    </span>
                    <template slot="createTime" slot-scope="createTime">
                        <span>{{changetime(createTime)}}</span>
                    </template>
                    <template slot="licenseType" slot-scope="licenseType">
                        <a-tag v-if="licenseType == 0" color="blue">经营许可证</a-tag>
                        <a-tag v-else-if="licenseType == 1" color="blue">生产许可证</a-tag>
                        <a-tag v-else-if="licenseType == 2" color="green">产品注册证</a-tag>
                    </template>
                    <template slot="customPic" slot-scope="text, record">
                        <a-popover placement="right" trigger="click">
                            <template slot="content">
                            <img :src="getImgUrl(record.attachment, record.imgLarge)" width="500px" />
                            </template>
                            <div style="width:52px;height:52px;" v-if="record.attachment">
                            <img v-if="record.attachment" :src="getImgUrl(record.attachment, record.imgSmall)" class="item-img" title="查看大图" style="width:100%;height:auto"/>
                            </div>
                        </a-popover>
                    </template>
                </a-table>
                
            </div>
        </a-modal>
        
    </div>
</template>
<script>
import addProductLicense from './addProductLicense'
import { getProductLisence, licenseDelete } from '@/api/api'
import { campListMixins } from '../mixins/campListMixins'
import { getFileAccessHttpUrl } from '@/api/manage'

export default { 
    name: 'campDetail',
    mixins: [campListMixins],
    components: {
        addProductLicense
    },
    data() {
      return { 
        title: '商品证照--证照列表',
        sureVisible:false,
        materialId: '',
        columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '证照类型', dataIndex: 'licenseType', width: 100, scopedSlots: { customRender: 'licenseType' } , render: (text) => text || "--" },
        { title: '证照编码', dataIndex: 'licenseCode',width: 120, render: (text) => text || "--"},
        { title: '有效期起', dataIndex: 'expirationDate', width: 120, render: (text) => text || "--" },
        { title: '有效期至', dataIndex: 'expirationEndDate', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        { title: '附件', dataIndex: 'attachment',width: 80, align: "center",scopedSlots: { customRender: 'customPic' } },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 140,
          scopedSlots: { customRender: 'action' },
        },
        ],
        // dataSource: {
        //     productName: '2'
        // }
      }
    },
    mounted(){
    },
    methods: {
        async initShow(e){
            console.log(e.result,'======================e===============')
            this.materialIds = e.materialId
            this.sureVisible = true
            let params= {
                uuid: e.uuid,
                materialId: e.materialId
            }
            const res = await getProductLisence(params)
            if( res.code == 200 && res.success == true){
                this.dataSource = res.result.records
            }else {
            this.$message.error(res.message)
            }
        },
        getImgUrl (imgName, type) {
            if (imgName && imgName.split(',')) {
                type = type ? type + '/' : ''
                return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
            } else {
                return ''
            }
        },
        handleAdd(){
            this.$refs.modalLicense.visible = true
            this.sureVisible = false
        },
        handleEdit(record){
            this.$refs.modalLicense.visible = true
            this.sureVisible = false
            this.$refs.modalLicense.edit(record)
            this.$refs.modalLicense.title = "编辑"
            
        },
        //商品证照删除
        async handleDelete(record) {
        let params = {
            id : record.licenseId
        }
        const res = await licenseDelete(params)
        if (res.code == 200 && res.success == true) {
            this.$message.success(res.message)
            this.dataSource = this.dataSource.filter(row => row !== record); 
        } else {
            this.$message.error(res.message)
        }
        this.visible = false
        this.loadData()
        },
        handleOk(){
            this.sureVisible = false
        },
        handleCancel(){
            this.sureVisible = false
        },
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
